var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "e645986d-a395-46f2-9d2a-6944ec235fb7",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon6",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon6",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/0f9a2fb9-3bf3-4c64-9b2d-1a9af15c3253/5c51f21e1f76d3ec3900c58fb722be9bdc65c090/",
    core: "4.5.1",
    title: "Deco2",
    type: "haiku",
    relpath: "code/deco2/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco2-20cb245cfb651e73": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 10.573,
        "sizeAbsolute.y": 10.908,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:fe2c42e13493": {
        "sizeAbsolute.y": 7,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 7,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 5.4510000000000005,
        "translation.y": 5.450000000000001,
        "style.zIndex": 3,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:037b0a2b4a01": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:21a0e732cf02": {
        fill: "#EF33F8",
        "translation.x": -7,
        "translation.y": -4
      },
      "haiku:6189c24d4441": {
        x: 7.32893795,
        y: 4.78998906,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 0.420298,
        "translation.y": -0.528424,
        "rotation.z": 0.05236
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco2-20cb245cfb651e73",
      "haiku-title": "Deco2"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "fe2c42e13493",
          "haiku-title": "deco2",
          "haiku-source":
            "designs/AnimatorWebsiteIcon6.sketch.contents/slices/deco2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "037b0a2b4a01",
              "haiku-title": "Page-1",
              id: "fc88fb5fbeef"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "21a0e732cf02",
                  "haiku-title": "Help-icon",
                  id: "cd592dc788cf"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "6189c24d4441",
                      "haiku-title": "deco2",
                      id: "0d6d88e8fc0a"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/deco2/code.js
// module id = 457
// module chunks = 127651196306611